define(function(require) {
    const BaseWidget = RhythmCommon.base.widget;
    var IpsModel = require('civicsBase/ipsModel');
    var IpsModelCollection = require('civicsBase/ipsModelCollection');
    var Validation = require('civicsUtils/backbone-nestedvalidation');
    var AnonLoginModel = require('civicsModels/anonymous_login_model');
    var ViewManager = require('civicsUtils/view_manager');
    const Utils = require('civicsUtils/general_utilities');
    const JSV = require('civicsUtils/JSV');
    const FeatureModel = require('civicsModels/portal/feature_model');
    const PortletConfigurationModel = require('civicsModels/portal/portlet_configuration_model');

    const FieldChangeUtility = require('civicsUtils/field_change_utility');
    const PortletControlChangeManager = require('civicsUtils/portlet_control_change_manager');
    const DataModelStore = require('civicsBase/data_model_store');
    const i18nOverride = require('civicsUtils/i18n_prefix_override');

	const user_data_utils = require('civicsUtils/user_data_utils');
    const twoFA = require('civicsViews/core/two_factor_authentication/2fa_utility');
    const twoFAUtil = new twoFA();
	user_data_utils.init();

    const processManager = require('civicsUtils/process_manager/process_manager');

    require('civicsBase/handlebars_helpers');
    require('civicsBase/handlebars_helpers_global');


	//necessary for old Marionette to work with newer versions of jQuery
	//https://github.com/marionettejs/backbone.marionette/issues/3077
	//https://github.com/marionettejs/backbone.marionette/pull/3081/files
	Marionette.Region.prototype.reset = function () {
		this.empty();

		this.el = this.options.el;

		delete this.$el;
		return this;
	};

    // todo gary: place holder for view loading
    Marionette.View.prototype.setLoading = function(progressBar){
      var self = this;
      var curr = parseInt(progressBar.attr('value')) ;
      if ( curr > 100 ){
        curr = 0;
      }
      //console.log( 'curr: ' +  curr+ 1);
      progressBar.attr('value', curr + 1 );
      clearTimeout(this.progress);
      this.progress = setTimeout(function(){
        self.setLoading(progressBar);
      }, 20);

    };
    Marionette.View.prototype.startLoading = function(progressBar){
      progressBar.attr('value',0);
      this.setLoading(progressBar);
    };
    Marionette.View.prototype.stopLoading = function(progressBar){
      clearTimeout(this.progress);
      progressBar.remove();
    };
    //end todo

    Marionette.View.prototype.setupFilterCodes = function(typeOfRecord, includesFieldChangeUtility = false, includeDefaultModelToStore = false) {

      if (ViewManager.versionRange('8.8.0.2301') !== true)
        return;

      //not all portlets contains the portletId in their config yet.
      if (this.config.portletId === undefined)
        return;

      if (includeDefaultModelToStore) {
        DataModelStore.set(this.config.portletId, this.FILTERCODEMODELID, {});
      }

      //items in the config view needed  portletId, agencyExtension, $el
      if (includesFieldChangeUtility) {
        let fieldChangeHandler = new FieldChangeUtility(this, this.FILTERCODEMODELID);
        fieldChangeHandler.setFieldChange(this.fieldChangeUtilityCallback);
      }

      //filterCodesList - pertains to the types of editable forms we support in page.
      let filterCodesList = DataModelStore.get("FilterCodesList", "list");
      if (filterCodesList === undefined) {
        DataModelStore.set("FilterCodesList", "list", []);
        filterCodesList = DataModelStore.get("FilterCodesList", "list");
      }


      if (!filterCodesList.includes(typeOfRecord)) {
        filterCodesList.push(typeOfRecord);
      }

      PortletControlChangeManager.applyChanges(this.config.elements, typeOfRecord);

    };

    Marionette.View.prototype.addToStore = function(namespace, key, value) {
      if (ViewManager.versionRange('8.8.0.2301') !== true)
        return;

      DataModelStore.set(namespace, key, value);
    }

    Marionette.View.prototype.getModelFromStore = function(namespace, key) {
      if (ViewManager.versionRange('8.8.0.2301') !== true)
        return;

      return DataModelStore.get(namespace, key);
    }

    Utils.updateSyphon();

    String.prototype.startsWith = function(prefix) {
        return this.indexOf(prefix) == 0;
    };

    String.prototype.endsWith = function(suffix) {
        if(suffix){
            return this.lastIndexOf(suffix) == this.length - suffix.length;
        }
        return false;
    };

    if (!String.prototype.includes){
        String.prototype.includes = function(value) {
            return this.indexOf(value) >= 0;
        };
    }

        //set validation to Ips model without having to bind a view
    _.extend(IpsModel.prototype, Validation.mixin);
    _.extend(IpsModelCollection.prototype, Validation.mixin);

    _.extend(Validation.validators, {
        validModel: function(value, attr, customValue, model) {
            if (value && !value.isValid(true)) {
                return 'Invalid ' + attr;
            }
        },
        validCollection: function(value, attr, customValue, model) {
            var errors = value.map(function(entry) {
                return entry.isValid(true);
            });
            if (_.indexOf(errors, false) !== -1) {
                return 'Invalid collection of ' + attr;
            }
        }
    });

    if (!String.prototype.format) {
        String.prototype.format = function() {
            var args = arguments;
            return this.replace(/{(\d+)}/g, function(match, number) {
                return typeof args[number] != 'undefined' ? args[number] : match;
            });
        };
    }
    if (!String.prototype.convertToReturnUrl){
      String.prototype.convertToReturnUrl = function() {
        // to conver query string into an actual return url
        // from start-project?{wizardtype:Config1,session:2361726327816}
        // to start-project/#wizardtype/Config1/session/2361726327816
        var returnUrl = this;
        var res = returnUrl.split('?');
        if ( res.length == 2){
          try {
              var o = JSV.parse(res[1]);
              returnUrl = res[0].urlPath(o);
          }
          catch(err) {
            if(__DEV__){
              console.log(err);
            }
          }
        }
        return returnUrl;
      };
    }
    if (!String.prototype.urlPath) {
        String.prototype.urlPath = function() {
            var params = arguments;
            var url = this;
            var first = true;
            if (params && params.length > 0) {
                // for each key value pair
                _.forEach(params, function(pair) {
                    // we do support one object with many key value pairs within
                    for (key in pair) {
                        if (pair.hasOwnProperty(key)) {
                            if (first) {
                                first = false;
                                url = url.urlCombine('#' + key, pair[key]);
                            } else {
                                url = url.urlCombine(key, pair[key]);
                            }
                        }
                    }
                });
            }
            return url;
        };
    }
    if (!String.prototype.urlCombine) {
        String.prototype.urlCombine = function() {
            var vals = arguments;
            var splitter = '/';
            if (_.isString(vals)) {
                return vals;
            }
            var url = this;
            // slice the last splitter for the current url root
            if (_.endsWith(url, splitter)) {
                url = url.slice(0, -1); // chop the last splitter character
            }

            _.forEach(vals, function(val) {
                var processed = val;
                if (_.endsWith(processed, splitter)) {
                    processed = processed.slice(0, -1); // chop the last splitter character
                }
                if (_.startsWith(processed, splitter)) {
                    processed = processed.slice(1); // chop the first splitter character
                }
                url = url + splitter + processed;
            });
            return url;
        };
    }


    if (!Date.yyyymmdd) {
        Date.prototype.yyyymmdd = function() {
            var YYYY = this.getFullYear().toString();
            var MM = (this.getMonth() + 1).toString(); // getMonth() is zero-based
            var DD = this.getDate().toString();
            var hh = this.getHours().toString();
            var mm = this.getMinutes().toString();
            var ss = this.getSeconds().toString();
            return YYYY + '-' + (MM[1] ? MM : "0" + MM[0]) + '-' + (DD[1] ? DD : "0" + DD[0]) + 'T' + (hh[1] ? hh : "0" + hh[0]) + ':' + (mm[1] ? mm : "0" + mm[0]) + ':' + (ss[1] ? ss : "0" + ss[0]); // padding
        };
    }
    // to support ol popup in ie
    (function () {
    if ( typeof window.CustomEvent === "function" ) return false;
    function CustomEvent ( event, params ) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent( 'CustomEvent' );
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
        return evt;
    }
    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
    window.Event = CustomEvent;
    })();

    var redirectIf403 = false;
    var redirectURL = "";
    var redirectMessage = "";
    const USER_SESSION = "USER_SESSION";

    return BaseWidget.extend({
        getFeature: function(featureId) {
          var featurePromise = $.Deferred();


          var feature = new FeatureModel();
          feature.id = featureId;

          feature.fetch().done(function(){
            featurePromise.resolve(feature);
          }).fail(function(){
            featurePromise.reject();
          });

          return featurePromise.promise();
        },
        getPortletConfig: function (portletId, sessionStorageId = '', globalFeatures = []) {
            var portletConfigPromise = $.Deferred();

            //have to add session storage access here for the reason that:
            //it is not only the performPrecheck where this getPortletConfig() being reference
            if (globalFeatures && globalFeatures.length == 0) {
              let globalConfigStr = App.sessionStorage.get('CIVICS', 'GLOBAL_CONFIG');
              if (globalConfigStr) {
                let convertedConfig = JSON.parse(globalConfigStr);
                globalFeatures = convertedConfig && convertedConfig.globalFeatures ? convertedConfig.globalFeatures : [];
              }
            }

            //SPC - represents the Use Back-office Portlet Configuration feature.
            //if this not present inside the array then we don't proceed on doing the fetch.
            if (portletId === undefined
                || (globalFeatures.includes('SPC') === false && ViewManager.versionRange('8.8.0.0', '8.8.0.2301'))) { //replace version number.
                portletConfigPromise.resolve({});
                return portletConfigPromise.promise();
            }

            let sessionKey = sessionStorageId.length > 0 ? sessionStorageId : portletId;
            if (App.sessionStorage.get('CIVICS', sessionKey)) {
                portletConfigPromise.resolve(App.sessionStorage.get('CIVICS', sessionKey));
            } else {
                var portletConfig = new PortletConfigurationModel();
                portletConfig.portletId = portletId;

                portletConfig.fetch().done(function () {
                    App.sessionStorage.set('CIVICS', sessionKey, portletConfig.toJSON());
                    portletConfigPromise.resolve(portletConfig.toJSON());
                }).fail(() => { portletConfigPromise.resolve({}) });
            }

            return portletConfigPromise.promise();

        },
        /**
         * This function invokes pre-auth call and site configuration such as global config
         * and portlet config etc...
         * @param {string} portletId - key that is use to get the portlet configuration in the service
         * @param {string} sessionStorageId - key to get the cache portlet configuration in the session storage
         * @returns Deferred object
         */
        performPreCheck: function (portletId, sessionStorageId = '') {
            // Apply i18n prefix override once, early, before any views render.
            // Individual widgets just set window._i18nPrefixOverride before calling this.
            i18nOverride.apply();

            twoFAUtil.checkRequireMFAEnrollment();

            twoFAUtil.setupMFAStorageListener();
                
            let performPreCheckRetPromise = $.Deferred();
            if(!App.promises)
                App.promises = {};

            // call the checkAuth once and let the others wait for the global checkAuthPromise variable to finish
            if (!App.promises.checkAuthPromise){
                App.promises.checkAuthPromise = new $.Deferred();
                App.portalUser = null;
                this.checkAuth(true);
            }
            $.when(App.promises.checkAuthPromise)
                .done((checkAuthResult) => {
                    ViewManager.loading(true);
                    let globalFeatures = checkAuthResult && checkAuthResult.globalFeatures ? checkAuthResult.globalFeatures : [];
                    //get portlet config might do a fetch, and if if does, we need to wait for it.
                    //if it is successful, then we have server side config.
                    //if not, it's fine, we don't have server side config. Note the always, rather than done/fail
                    $.when(this.getPortletConfig(portletId, sessionStorageId, globalFeatures)).always((portletConfigResult)=>{
                        ViewManager.loading(false);
                        performPreCheckRetPromise.resolve(portletConfigResult);
                    })

                    if( !App.user.isLoggedIn ){
                        this.checkElectronicPlanLogout();
                        this.processRedirect();
                    }

                })
                .fail((checkAuthResult) => {
                    if (checkAuthResult && checkAuthResult.isMaintenanceMode) {
                        performPreCheckRetPromise.reject(checkAuthResult);
                    } else {
                        performPreCheckRetPromise.resolve({})
                    }
                });

            return performPreCheckRetPromise;
        },
        

        checkAuth: function(retry){
            //if retry is true, then retry the login, else just give error.
            if(__DEV__)console.log("Check Auth Start");
            ViewManager.loading(true);
            let userSession = this.getUserSession();
            if(!userSession){
                let Probe = IpsModel.extend({
                    urlRoot: '/delegate/civics-api/api/portal/users',
				parse(response){
					return response.data;
				}});
                let probe = new Probe();
                probe.fetch({isCheckAuthRequest:true})
                .done((response, status, xhrResponse)=>{
                    //we are logged in as a portal user
                    this.processLoggedInUser(response.data, true);
                })
                .fail((response, status, xhrResponse)=> {
                    //if( 401 ) we are not logged in at all and need to auth with anon user
                    App.portalUser = 0;
                    if( response.status === 401){
                        $.when(this.login()).done((result)=>{
                            App.promises.checkAuthPromise.resolve(result)
                        });

                        this.checkElectronicPlanLogout();
                        if(__DEV__)console.log("Check Auth 401");
                    }
                    else if( response.status === 403){    //if(403) we are logged in as anon user and that is ok
                        this.processAnonUser();
                    }
                    else if( response.status === 423){   //if 423 we are in maintenance mode
                        this.processMaintenanceMode();
                    }
                    else if (status === "abort") { //  indicates that the request was stopped
                      //likely due to a page redirect or the user canceling. In this case, do nothing
                      //we don't even want an error message to appear
                    }
                    else{
                        if(__DEV__)console.log("Check Auth fail");
                        //we had another services error.
                        //Attempt again if retry is true.
                        if( retry != undefined && retry === true){
                            this.checkAuth(false);      //set retry to false.  We are only trying 2x max.
                        }
                        else {
                            //site is not up,
                            ViewManager.openAlert( i18n.t('CIVICS.COMMON.SERVER_ERRORS.SERVICES_DOWN') );
                            this.checkElectronicPlanLogout();

                            App.promises.checkAuthPromise.resolve();
                            if(__DEV__)console.log("Check Auth fail - BeforeInit Done");
                        }
                    }

                    ViewManager.loading(false);
                });
            }else{
                if(userSession.isMaintenanceMode){
                    this.processMaintenanceMode();
                }else if(userSession.isAnonUser){
                    this.processAnonUser();
                }else{
                    this.processLoggedInUser(userSession);
                }
            }
        },
        getUserSession: function(){
			let storedRhythmSessionID = App.sessionStorage.get('CIVICS', 'RHYTHM_SESSION_ID' );
			let currentRhythmSessionID = Utils.getCookie('RhythmSessionId');
            let userSessionString = App.sessionStorage.get('CIVICS', USER_SESSION);
            // when RhythmSessionId change, it indicates the we do logout so we need to do the user call
            // else get the user session on session storage
            if(!currentRhythmSessionID || !userSessionString || storedRhythmSessionID != currentRhythmSessionID){
                return null;
            }else{
                return JSON.parse(userSessionString);
            }
        },
        // process when checkAuth logged in as Anon
        processAnonUser: function(){
            if(__DEV__)console.log("Check Auth 403");
            $.when(this.loadGlobalConfig()).done((result)=>{
                App.promises.checkAuthPromise.resolve(result)
                ViewManager.loading(false);
            });
            this.checkElectronicPlanLogout();
            this.processRedirect();
        },
        processRedirect: function(){
            
            if( this.redirectIf403 == true ){
                if( this.redirectURL && this.redirectURL != "" ){
                    if( this.redirectMessage && this.redirectMessage != "" )
                        App.sessionStorage.set('CIVICS', 'REDIRECT_MESSAGE', this.redirectMessage );
                    window.location.replace(this.redirectURL);
                }
            } else {
                processManager.resumeProcess();
            }
        },
        // process when we are on maintenance mode. store the isMaintenanceMode flag on UserSession so on every page load, the maintenance mode error will show
        processMaintenanceMode: function(){
            let result = { isMaintenanceMode: true }
            App.sessionStorage.set( 'CIVICS', USER_SESSION, JSON.stringify({isMaintenanceMode: true}));
            App.promises.checkAuthPromise.reject(result);
            this.checkElectronicPlanLogout();
            ViewManager.loading(false);
            ViewManager.openAlert( i18n.t('CIVICS.COMMON.SERVER_ERRORS.MAINT_MODE'), true );
        },
		 processLoggedInUser: function(result, fromRS = false){
            if(result){
				user_data_utils.processUserResponse(result, fromRS);//this call sets the App.user.[user information] parameters
            }
            ViewManager.loading(false);
            if(__DEV__)console.log("Check Auth 200");
            $.when(this.loadGlobalConfig()).done((result)=>{
                App.promises.checkAuthPromise.resolve(result)
                ViewManager.loading(false);
            });
        },
        checkElectronicPlanLogout: function(){
            let ePlanLogoutURL = App.sessionStorage.get('CIVICS', 'EPLAN_LOGOUT_URL');
            if(ePlanLogoutURL && ePlanLogoutURL.length > 0){
                if(document.body){
                    let ePlanIFrame = document.createElement("iframe");
                    ePlanIFrame.setAttribute("src", ePlanLogoutURL);
                    ePlanIFrame.style.display = 'none';
                    document.body.appendChild(ePlanIFrame);
                    App.sessionStorage.remove('CIVICS', 'EPLAN_LOGOUT_URL');
                }
            }
        },
        login: function() {
            let loginAnonPromise = $.Deferred();
            var login = new AnonLoginModel();       //The authentication controller will convert this to use the Anonymous user name set up in tenant config.
            if(__DEV__)console.log("Anonymous Login Start");
            //Authenticate with the Anonymous Portal User
            ViewManager.loading(true);
            login.fetch().done(()=>{
                if(__DEV__)console.log("Anonymous Login Success");
                ViewManager.loading(false);
                App.sessionStorage.set( 'CIVICS', USER_SESSION, JSON.stringify({isAnonUser: true})); // save isAnonUser on user session. This is need for the next load since we will not execute the checkAuth if the user didn't change
                $.when(this.loadGlobalConfig()).done((result)=>{
                    loginAnonPromise.resolve(result)
                });
            })
            .fail((response, status, xhrResponse)=> {
                if(__DEV__)console.log("Anonymous Login failed");
                ViewManager.loading(false);
                if( response.statusCode().status == 423 ){
                    ViewManager.openAlert( i18n.t('CIVICS.COMMON.SERVER_ERRORS.MAINT_MODE'), true);
                    App.promises.checkAuthPromise.reject();
                }

                loginAnonPromise.resolve()
            })
            return loginAnonPromise;
        },
        loadGlobalConfig: function(){
            // call the globalConfig once and let the other wait for the global globalConfigPromise variable to finish
            if(!App.promises.globalConfigPromise){
                App.promises.globalConfigPromise = $.Deferred();
                ViewManager.loading(true);
                ViewManager.globalConfig(App.promises.globalConfigPromise);
                ViewManager.loading(false);
            }

            return App.promises.globalConfigPromise;
        }
    });
});
